import {validateColorAndPerformCastingIfNecessary} from '../../../privates/validations/styleValidation';
import styleService from './styleService';
import * as members from '../../../privates/privateMembers';
import StyleProperties from '../../../privates/styleConstants';

class ForegroundColorMixin {

  /**
   * @member foregroundColor
   * @memberof $w.Style
   * @param {external:String} foregroundColor
   */
    set foregroundColor(foregroundColor) {
         const compName = members._compName.get(this);
         const opacitySupport = true;

        const validColor = validateColorAndPerformCastingIfNecessary(foregroundColor, opacitySupport, StyleProperties.FOREGROUND_COLOR, compName);
        if (!validColor){
            return;
        }
        styleService.setStyle.call(this, StyleProperties.FOREGROUND_COLOR, validColor);
    }

    /**
     * @member foregroundColor
     * @label property
     * @syntax
     * get foregroundColor(): string
     * set foregroundColor(rgbaColor: string): void
     * @summary Sets or gets the foreground color of an element.
     * @description
     *  The foreground color value is a string representing an rgba color in one
     *  of the following formats:
     *
     *  + `"red"`: One of [140 predefined color names](https://www.w3schools.com/colors/colors_names.asp).
     *  + `"#FF0000"`: A hexidecimal rgb color value.
     *  + `"rgb(255,0,0)"`: An rgb() function color value.
     *  + `"#FF000000"`: A hexidecimal rgba color value.
     *  + `"rgba(255,0,0,1.0)"`: An rgba() function color value.
     * 
     * This style can be used with the following elements: 
     * 
     *  + [`ProgressBar`]($w.ProgressBar.html)
     * 
     * @snippet [ForegroundColorMixin-foregroundColor_set.es6=Set the foreground color]
     * @snippet [ForegroundColorMixin-foregroundColor_get.es6=Get the foreground color]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    get foregroundColor() {
       return styleService.getStyleParamValue.call(this, StyleProperties.FOREGROUND_COLOR);
    }

}

export default ForegroundColorMixin;
